export default {
    API_URL: 'https://admin.dev.into-it.co.uk'
}
